'use client'

import { cn } from '@/lib/utils'
import { Fragment, forwardRef } from 'react'
import Text from '../../text'

interface AnimatedBannerItemProps {
  texts?: string[]
  className?: string
}

const AnimatedBannerItem = forwardRef<HTMLUListElement, AnimatedBannerItemProps>(
  ({ texts, className, ...props }, ref) => {
    if (!texts) return null

    return (
      <ul
        ref={ref}
        className={cn(
          'flex shrink-0 items-center py-4 leading-9 text-white sm:py-9 [&_img]:max-w-none [&_li]:mx-8',
          className,
        )}
        {...props}
      >
        {texts.map((text, index) => (
          <Fragment key={`animatedBanner${index}`}>
            <li>
              <Text
                as="span"
                uppercase
                className="whitespace-nowrap text-xs leading-9 tracking-[calc(10/16*1rem)] sm:text-xl md:text-2xl"
              >
                {text}
              </Text>
            </li>

            <li>
              <Text
                as="span"
                uppercase
                className="whitespace-nowrap text-xs leading-9 sm:text-xl md:text-2xl"
              >
                + + +
              </Text>
            </li>
          </Fragment>
        ))}
      </ul>
    )
  },
)

AnimatedBannerItem.displayName = 'AnimatedBannerItem'

export default AnimatedBannerItem
